import { ownersDuckCreator } from 'axl-ducks';

const ownersDuck = ownersDuckCreator();
export default ownersDuck;
